import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeColor, GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { TerminationCause } from '@vendasta/protos/voice/v1alpha1';

interface CallEndDisplay {
  labelKey: string;
  color: BadgeColor;
}

const CALL_END_DISPLAY: Partial<Record<TerminationCause, CallEndDisplay>> = {
  [TerminationCause.TERMINATION_CAUSE_AI_HANGUP]: { labelKey: 'INBOX.EVENTS.PHONE.CALL_END_AI_HUNG_UP', color: 'grey' },
  [TerminationCause.TERMINATION_CAUSE_AI_TRANSFER]: {
    labelKey: 'INBOX.EVENTS.PHONE.CALL_END_AI_TRANSFERRED',
    color: 'blue',
  },
  [TerminationCause.TERMINATION_CAUSE_CALLER_HANGUP]: {
    labelKey: 'INBOX.EVENTS.PHONE.CALL_END_CALLER_ENDED',
    color: 'grey',
  },
  [TerminationCause.TERMINATION_CAUSE_TIMEOUT]: { labelKey: 'INBOX.EVENTS.PHONE.CALL_END_TIMED_OUT', color: 'yellow' },
  [TerminationCause.TERMINATION_CAUSE_CARRIER_ERROR]: {
    labelKey: 'INBOX.EVENTS.PHONE.CALL_END_CARRIER_ERROR',
    color: 'red',
  },
  [TerminationCause.TERMINATION_CAUSE_PROVIDER_ERROR]: {
    labelKey: 'INBOX.EVENTS.PHONE.CALL_END_PROVIDER_ERROR',
    color: 'red',
  },
  [TerminationCause.TERMINATION_CAUSE_CONNECTION_ERROR]: {
    labelKey: 'INBOX.EVENTS.PHONE.CALL_END_CONNECTION_ERROR',
    color: 'red',
  },
};

@Component({
  selector: 'inbox-call-end-indicator',
  templateUrl: './call-end-indicator.component.html',
  styleUrl: './call-end-indicator.component.scss',
  imports: [TranslateModule, GalaxyBadgeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CallEndIndicatorComponent {
  readonly terminationCause = input<TerminationCause | undefined>();

  // Resolves to null for INVALID, unset/loading, and any unmapped value, so the
  // indicator self-hides. Only a mapped, localized label is ever rendered — the
  // raw enum value never reaches the DOM.
  readonly display = computed<CallEndDisplay | null>(() => {
    const cause = this.terminationCause();
    return cause ? (CALL_END_DISPLAY[cause] ?? null) : null;
  });
}
